module.exports = __webpack_public_path__ + "py.svg?f1fa6887d16e8626a2ece3b50b551718";


//////////////////
// WEBPACK FOOTER
// ./node_modules/flag-icon-css/flags/1x1/py.svg
// module id = 1326
// module chunks = 0